/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * Columns that can be exported in the CSV assignment report.
 *
 * The values are the column headers used in the generated CSV.
 */
export const AssignmentExportColumn = /* #__PURE__ */ parsers.exactly('id', 'username', 'name', 'grade', 'created_at', 'assigned_to', 'general_feedback', 'line_feedback');
